import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sercret-sylvans',
  templateUrl: './sercret-sylvans.component.html',
  styleUrls: ['./sercret-sylvans.component.css']
})
export class SercretSylvansComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
